import LazyImage from '@/components/common/lazy-image';
import { PromotionalApp } from '@/infrastructure/class/promotional-app';
import { EMPTY_IMAGE_PATH } from '@/infrastructure/const/empty-image-path';
import React, { useEffect, useState } from 'react';
import { isIOS, isMacOs } from 'react-device-detect';
import s from './styles.module.scss';
import OpenButton from '@/components/buttons/open';

interface IOurAppsListItemProps {
  data: PromotionalApp;
  className?: string;
}

const OurAppsListItem: React.FC<IOurAppsListItemProps> = (props) => {
  const { data, className = '' } = props;

  const [icon] = useState<string>(
    !!data.icon ? data.icon.mediumUrl : EMPTY_IMAGE_PATH
  );
  const [appLink, setAppLink] = useState<string>(
    isMacOs || isIOS ? data.link_ios : data.link_android
  );

  useEffect(() => {
    setAppLink(isMacOs || isIOS ? data.link_ios : data.link_android);
  }, [data.link_android, data.link_ios]);

  return (
    <li className={s['item']}>
      <div className={s['app-icon']}>
        <LazyImage
          className={s['image']}
          alt={data.title}
          src={icon}
          width={100}
          height={100}
        />
      </div>
      <div className={s['info']}>
        <p className={s['title']}>{data.title.toLocaleLowerCase()}</p>
        <p className={s['description']}>{data.description}</p>
      </div>

      <a href={appLink} target="_blank">
        <OpenButton />
      </a>
    </li>
  );
};

export default OurAppsListItem;
